module.exports = {"231024100":"东宁镇","231024101":"三岔口镇","231024102":"大肚川镇","231024103":"老黑山镇","231024104":"道河镇","231024105":"绥阳镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231024.json
// module id = 719
// module chunks = 0